import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import { PageContent } from '../services/models/seo';

export type SeoProvider = PageContent;

const SeoContext = createContext<SeoProvider>({} as PageContent);

export const useSeoContent = () => useContext(SeoContext);

const SeoContextProvider = ({ children, value }) => {
  return <SeoContext.Provider value={value}>{children}</SeoContext.Provider>;
};

SeoContextProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.shape({}),
};

SeoContextProvider.defaultProps = {
  children: {},
  value: {},
};

export default SeoContextProvider;
